import { ComponentProps } from 'react';
import ReactSelect from 'react-select';
import styled from 'styled-components';
import { colors } from '../common/constants';

export const StyledSelect = styled.div`
  .react-select {
    &__input-container {
      margin: 0;
    }

    &__indicators {
      position: absolute;
      top: 0;
      right: 0;
    }
  }

  .react-select__control {
    min-height: calc(3rem - 1px);
  }

  .react-select__indicator-separator {
    display: none;
  }

  .react-select__indicator {
    padding: 4px;
  }

  .react-select__placeholder {
    font-size: 1rem;
  }
`;

const findValue = (options: any, value: any): any => {
  if (value == null) {
    return value;
  }

  const flatOptions = options.flatMap((o: any) => (o.options ? o.options : o));

  return flatOptions.find((item: any) => item.value === value);
};

export const Select = (props: ComponentProps<ReactSelect>) => {
  return (
    <StyledSelect>
      <ReactSelect
        {...props}
        value={findValue(props.options, props.value)}
        onChange={(o: any, actionMeta) => props.onChange?.(o.value, actionMeta)}
        classNamePrefix="react-select"
        theme={(theme) => ({
          ...theme,
          colors: {
            ...theme.colors,
            primary: colors.primary,
          },
        })}
      />
    </StyledSelect>
  );
};

export default Select;
